let REACT_APP_API_URL = process.env.REACT_APP_API_URL
const currentDomain = window.location.origin
if (currentDomain !== process.env.REACT_APP_API_URL) {
  REACT_APP_API_URL = currentDomain
}

export const API_CENTRAL_PRODUCTS_V2 = `${REACT_APP_API_URL}/api/v2.0/accounts/products`
export const API_CENTRAL_GENERATE_KEYWORD = `${REACT_APP_API_URL}/api/v2.0/generate-keyword`